import { SigningWorkspace } from './components/SigningWorkspace';
import { ErrorBoundary } from './components/ErrorBoundary';

function App() {
  // Wrap in an error boundary so a render throw in the workspace doesn't
  // white-out the whole app; placed fields stay recoverable from snapshots.
  return (
    <ErrorBoundary>
      <SigningWorkspace />
    </ErrorBoundary>
  );
}

export default App;
